import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';

export const previousRowExist = (prevLivePlayIndex: number): boolean => {
  return prevLivePlayIndex >= 0;
};

export const previousRowIsInSameInningSide = (rows: ReviewDataRow[], row: ReviewDataRow, prevLivePlayIndex: number): boolean => {
  return (
    rows[prevLivePlayIndex].inning.inningNumber === row.inning.inningNumber &&
    rows[prevLivePlayIndex].inning.isTopInning === row.inning.isTopInning
  );
};
